var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"abstract-2",attrs:{"src":require('@/assets/abstract2.png'),"height":"711","width":"778"}})}
var staticRenderFns = []

export { render, staticRenderFns }